import axios from 'axios'

const apiURL = process.env.REACT_APP_API_URL

export interface ToolCost {
  toolCostId?: number
  toolId?: number
  description?: string
  cost?: number
  date?: string
}

export const getToolCostsByTool = async (toolId: number): Promise<ToolCost[]> => {
  const token = localStorage.getItem('authToken')
  if (!token) throw new Error('Authorization token not found')

  const response = await axios.get<ToolCost[]>(
    `https://${apiURL}/ToolCost/tool/${toolId}`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
    }
  )
  return response.data
}

export const createToolCost = async (toolCost: ToolCost): Promise<ToolCost> => {
  const token = localStorage.getItem('authToken')
  if (!token) throw new Error('Authorization token not found')

  const response = await axios.post<ToolCost>(
    `https://${apiURL}/ToolCost`,
    toolCost,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
    }
  )
  return response.data
}

export const updateToolCost = async (id: number, toolCost: ToolCost): Promise<void> => {
  const token = localStorage.getItem('authToken')
  if (!token) throw new Error('Authorization token not found')

  await axios.put(
    `https://${apiURL}/ToolCost/${id}`,
    toolCost,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
    }
  )
}

export const deleteToolCost = async (id: number): Promise<void> => {
  const token = localStorage.getItem('authToken')
  if (!token) throw new Error('Authorization token not found')

  await axios.delete(`https://${apiURL}/ToolCost/${id}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })
}

export const getToolCostDocuments = async (toolCostId: number): Promise<any[]> => {
  const token = localStorage.getItem('authToken')
  const storedApiURL = localStorage.getItem('apiURL')
  const finalApiURL = storedApiURL || apiURL

  if (!token) throw new Error('Authorization token not found')

  try {
    const response = await axios.get(
      `https://${finalApiURL}/ToolCost/${toolCostId}/Documents`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + token,
        },
      }
    )
    return response.data
  } catch (error) {
    console.error('Error fetching tool cost documents:', error)
    return []
  }
}
